export const STORAGE_KEY = "onboarding";
